import CTNCheckbox from '@ctn/ui/components/ctn-checkbox';
import { useEffect, type ReactElement } from 'react';
import { useFormContext } from 'react-hook-form';

import { type FormValues } from '@/interfaces/model/don.interface';

const PrivacyPolicy = (): ReactElement => {
	const {
		control,
		setValue,
		watch
	} = useFormContext<FormValues>();
	const valorPolitica = watch('politicaAceptada');

	useEffect(() => {
		if (valorPolitica === undefined) {
			setValue('politicaAceptada', [], { shouldDirty: false });
		}
	}, [valorPolitica]);

	return (
		<div className="c-pnp-privacy-policy [ u-mt-24 ]">
			<p className="c-pnp-privacy-policy__title">
				POLÍTICA DE PRIVACIDAD
			</p>
			<p className="c-pnp-privacy-policy__desc">
				Queda informado del tratamiento de sus datos personales por el Notario con la finalidad de 
				cumplir la normativa notarial para autorizar o intervenir el documento solicitado, 
				su facturación, seguimiento posterior y las funciones propias de la actividad notarial de obligado cumplimento; 
				los datos se conservarán durante los años necesarios para el cumplimiento de las obligaciones 
				legales del ejercicio de la función pública notarial; los datos se conservarán durante los años 
				necesarios para cumplir con las obligaciones legales del Notario o quien le sustituya o suceda, 
				realizándose únicamente las cesiones que sean de obligado cumplimiento a las Administraciones Públicas 
				que estipule la Ley y, en su caso, al Notario que suceda o sustituya al actual en la Notaría; 
				puede ejercitar sus derechos de acceso, rectificación, supresión, limitación, portabilidad y 
				oposición al tratamiento por correo postal ante la Notaría autorizante, y así mismo, 
				tiene el derecho a presentar una reclamación ante una autoridad de control (AEPD); si se 
				facilitasen datos de terceros, asume la responsabilidad de obtener previamente su consentimiento 
				para comunicar dichos datos al Notario, debiendo haberles informado previamente de la 
				política de privacidad antes indicada.
			</p>
			{valorPolitica !== undefined && (
				<CTNCheckbox
					classNameField="[ c-pnp-privacy-policy__checkbox ] [ u-mt-16 ]"
					name="politicaAceptada"
					items={[
						{
							label: 'Acepto la política privacidad.',
							value: '1',
						},
					]}
					noFeedBack={false}
					control={control}
				/>
			)}
		</div>
	);
};

export default PrivacyPolicy;